export const IMPORT_TYPE = 'CLAIM_EXTERNAL_PAYMENT_IMPORT';

export const BATCH_FILE_IMPORT_API_ROOT = '/sxcl/v1/batch-file-import';

export const statusOptions = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'In Progress', value: 'IN_PROGRESS' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Failed', value: 'FAILED' },
];

const getUploadContentType = file => file.type || 'application/json';

export const createApis = () => ({
  list: dataProvider =>
    `${dataProvider.getApiUrl()}${BATCH_FILE_IMPORT_API_ROOT}?importType=$eq:${IMPORT_TYPE}`,
  createBatch: (dataProvider, file) =>
    dataProvider.post(
      `${dataProvider.getApiUrl()}${BATCH_FILE_IMPORT_API_ROOT}`,
      {
        fileName: file.name,
        importType: IMPORT_TYPE,
      },
    ),
  getUploadContentType,
  getUploadUrl: (dataProvider, batchId, file) =>
    dataProvider.post(
      `${dataProvider.getApiUrl()}${BATCH_FILE_IMPORT_API_ROOT}/${batchId}/upload`,
      {
        fileName: file.name,
        contentType: getUploadContentType(file),
      },
    ),
  listDetails: (dataProvider, batchId) =>
    `${dataProvider.getApiUrl()}${BATCH_FILE_IMPORT_API_ROOT}/${batchId}/details`,
});
